var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left-right (Exchange icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.6391 19.1751L26.3891 14.3002C26.0609 13.9955 25.5875 13.9158 25.175 14.0939C24.7625 14.272 24.5 14.6798 24.5 15.1252V19.2501H15.5L15.5 15.1252C15.5 14.6776 15.2349 14.2725 14.8246 14.0939C14.4142 13.9153 13.9391 13.9955 13.6109 14.3002L8.36094 19.1751C8.11991 19.4001 8 19.7001 8 19.9579C8 20.2158 8.11991 20.5603 8.35967 20.7829L13.6097 25.6579C13.937 25.9619 14.4145 26.0432 14.8247 25.8644C15.2348 25.6857 15.5001 25.2809 15.5001 24.8332L15.5 20.7501H24.5L24.5 24.8751C24.5 25.3226 24.7652 25.7278 25.1755 25.9064C25.5859 26.0849 26.0633 26.0038 26.3905 25.6998L31.6405 20.8248C31.8781 20.6001 32 20.3001 32 19.9579C32 19.6158 31.8781 19.4001 31.6391 19.1751ZM14 24.0173L9.67578 20.0001L14 15.983V24.0173ZM26 24.0173V15.983L30.3219 20.0001L26 24.0173Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.dd68cee8dfd436890ed28dedaba5a3f8.svg";
export { ForwardRef as ReactComponent };